<div class="container" (click)="onClick()">
   <button kendoButton look="flat" class="sam-full-width primary" fxLayout="column">
      <div class="sam-form-row" style="margin-bottom: 0; width: 100%" fxLayout="row">
         <samweb-guest-info [chatGuestInfo$]="chatGuestInfo$"></samweb-guest-info>
         <div
            class="number-of-unread-messages"
            *samwebVar="numberOfUnreadMessages$ | async; let numberOfUnreadMessages"
         >
            <samweb-unread-messages-badge
               *ngIf="numberOfUnreadMessages"
               [numberOfUnreadMessages]="numberOfUnreadMessages"
               [showNumber]="false"
            ></samweb-unread-messages-badge>
         </div>
      </div>
      <div
         *samwebVar="lastMessage$ | async; let lastMessage"
         class="sam-form-row sam-full-width last-message"
         fxLayout="row"
      >
         <samweb-chat-message [message]="lastMessage" *ngIf="lastMessage" class="sam-full-width"></samweb-chat-message>
      </div>
   </button>
</div>
